const archives = document.querySelectorAll('.filterable-post-archive__filters');

if (archives) {
	for (let i = 0; i < archives.length; i++) {
		const archive = archives[i];

		const buttons = archive.querySelectorAll('.filter-toggles button');
		const filters = archive.querySelectorAll('.filters li');
		for (let j = 0; j < buttons.length; j++) {
			const button = buttons[j];
			const filter = filters[j];
			buttons[j].addEventListener('click', () => {
				if (filter.classList.contains('active')) {
					for (i = 0; i < filters.length; i++) {
						buttons[i].classList.remove('active');
						filters[i].classList.remove('active');
					}
				} else {
					for (i = 0; i < filters.length; i++) {
						buttons[i].classList.remove('active');
						filters[i].classList.remove('active');
					}
					filter.classList.add('active');
					button.classList.add('active');
				}
			});
		}
	}
}
